import _ from 'lodash';
import React from 'react';

import Table from 'components/Table';

import {formatDate} from 'utils/datetime';

const renderRow = verification => (
  <Table.Row key={verification.id} className="KycVisaVerificationRow">
    <Table.Cell>{formatDate(verification.createdAt)}</Table.Cell>
    <Table.Cell>{_.get(verification, 'createdBy.fullName')}</Table.Cell>
    <Table.Cell>{formatDate(verification.expiryDate)}</Table.Cell>
  </Table.Row>
);

const KycVisaVerificationsTable = ({verifications, label}) => (
  <div className="KycVisaVerificationsTable KycTable KycHistoryTable">
    <div className="tableHeading">{label} Verification History</div>
    <Table>
      <Table.Header>
        <Table.HeaderItem heading="date" />
        <Table.HeaderItem heading="verified by" />
        <Table.HeaderItem heading="expires" />
      </Table.Header>
      <Table.Body>{verifications.map(renderRow)}</Table.Body>
    </Table>
  </div>
);

export default KycVisaVerificationsTable;
